import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StatusDot, Tooltip } from '@wit-support/ui';
import { Time } from './time.js';
import { cn } from './lib/cn.js';
/**
 * Состояние движка одной точкой (§4 «Health dot»): не подключён / недоступен
 * / работает, но последний сбор с ошибками или есть тревоги уровня «ошибка» /
 * работает. `null` — ответа ещё нет.
 */
export function contentEngineHealthLevel(h) {
    if (!h)
        return 'unknown';
    if (!h.configured)
        return 'off';
    if (h.reachable === false)
        return 'down';
    if ((h.lastCollectorRun?.errors ?? 0) > 0 || (h.alerts?.error ?? 0) > 0)
        return 'warn';
    return 'ok';
}
const LEVEL = {
    ok: { variant: 'green', label: 'Движок работает' },
    warn: { variant: 'amber', label: 'Движок работает, есть ошибки' },
    down: { variant: 'red', label: 'Движок недоступен' },
    off: { variant: 'slate', label: 'Движок не подключён' },
    unknown: { variant: 'slate', label: 'Проверяем движок…' },
};
/** Точка здоровья движка с подписью; подробности (сбор, тревоги) — в подсказке. */
export function ContentEngineHealthDot({ health, className }) {
    const level = contentEngineHealthLevel(health);
    const { variant, label } = LEVEL[level];
    const run = health?.lastCollectorRun ?? null;
    const alerts = health?.alerts ?? null;
    const details = run || alerts ? (_jsxs("span", { className: "flex flex-col gap-0.5", children: [run ? (_jsxs("span", { children: ["\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u0438\u0439 \u0441\u0431\u043E\u0440: ", _jsx(Time, { iso: run.finishedAt ?? run.startedAt, preset: "dateTime" }), run.finishedAt === null ? ' (идёт)' : '', run.errors > 0 ? `, ошибок: ${run.errors}` : ''] })) : null, alerts ? (_jsxs("span", { children: ["\u041E\u0442\u043A\u0440\u044B\u0442\u044B\u0435 \u0442\u0440\u0435\u0432\u043E\u0433\u0438: \u043E\u0448\u0438\u0431\u043A\u0430 ", alerts.error, ", \u0432\u043D\u0438\u043C\u0430\u043D\u0438\u0435 ", alerts.warn, ", \u043A \u0441\u0432\u0435\u0434\u0435\u043D\u0438\u044E", ' ', alerts.info] })) : null] })) : null;
    const badge = (_jsxs("span", { className: cn('inline-flex items-center gap-1.5 text-xs text-[var(--color-text-muted)]', className), "data-level": level, ...(details ? { tabIndex: 0 } : {}), children: [_jsx(StatusDot, { variant: variant, "aria-label": label }), _jsx("span", { children: label })] }));
    if (!details)
        return badge;
    return (_jsx(Tooltip.Provider, { children: _jsxs(Tooltip.Root, { children: [_jsx(Tooltip.Trigger, { asChild: true, children: badge }), _jsx(Tooltip.Content, { className: "max-w-xs whitespace-normal", children: details })] }) }));
}
//# sourceMappingURL=content-engine-health.js.map